import i18n from '../lang/index'


var APP_CONFIG = {

  RgxEDS16_Version: /^eds-pro_16/,

  // 下拉刷新时提示的内容模版
  tTOP_DEFAULT_CONFIG() {
    return {
      pullText: i18n.t('下拉刷新'), // 下拉时显示的文字
      triggerText: i18n.t('释放更新'), // 下拉到触发距离时显示的文字
      loadingText: i18n.t('加载中...'), // 加载中的文字
      doneText: i18n.t('加载完成'), // 加载完成的文字
      failText: i18n.t('没有数据可以加载'), // 加载失败的文字
      loadedStayTime: 400, // 加载完后停留的时间ms
      stayDistance: 50, // 触发刷新后停留的距离
      triggerDistance: 70 // 下拉刷新触发的距离 
    }
  },

  // 下拉刷新时提示的内容模版2
  tTOP_DEFAULT_CONFIG2() {
    return {
      pullText: i18n.t('下拉加载更多'), // 下拉时显示的文字
      triggerText: i18n.t('释放加载更多'), // 下拉到触发距离时显示的文字
      loadingText: i18n.t('加载中...'), // 加载中的文字
      doneText: i18n.t('加载完成'), // 加载完成的文字
      failText: i18n.t('没有数据可以加载'), // 加载失败的文字
      loadedStayTime: 400, // 加载完后停留的时间ms
      stayDistance: 50, // 触发刷新后停留的距离
      triggerDistance: 70 // 下拉刷新触发的距离 
    }
  },

  // 上拉加载时显示的内容模版
  tBOTTOM_DEFAULT_CONFIG() {
    return {
      pullText: i18n.t('上拉加载'),
      triggerText: i18n.t('释放更新'),
      loadingText: i18n.t('加载中...'),
      doneText: i18n.t('加载完成'),
      failText: i18n.t('已经到底了!'),
      loadedStayTime: 400,
      stayDistance: 50,
      triggerDistance: 70
    }
  },

  // 上拉加载时显示的内容模版
  tBOTTOM_DEFAULT_CONFIG2() {
    return {
      pullText: i18n.t('上拉更新'),
      triggerText: i18n.t('释放更新'),
      loadingText: i18n.t('加载中...'),
      doneText: i18n.t('更新完成'),
      failText: i18n.t('已经最新了!'),
      loadedStayTime: 400,
      stayDistance: 50,
      triggerDistance: 70
    }
  },

  // 网络请求超时时间, 单位毫秒
  timeout: 10 /* s */ * 1000,
}


export default APP_CONFIG
